import type {
  AccountRepository,
  MessageRepository,
} from '@/apis/usecases/dataAccesses'
import { TYPES } from '@/libs/di/types'
import { ContainerModule } from 'inversify'

import {
  AccountRepositoryImpl,
  MessageRepositoryImpl,
} from '@/apis/repositories'

export const repositories = new ContainerModule(bindOptions => {
  bindOptions
    .bind<MessageRepository>(TYPES.MessageRepository)
    .to(MessageRepositoryImpl)
  bindOptions
    .bind<AccountRepository>(TYPES.AccountRepository)
    .to(AccountRepositoryImpl)
})
